var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M348.438 85.124h-50.277c1.779-22.101-5.748-44.817-22.617-61.687-30.522-30.52-80.183-30.52-110.705 0L149.236 39.04l-15.603-15.603c-30.522-30.522-80.184-30.521-110.705.001C8.143 38.222 0 57.881 0 78.79s8.142 40.567 22.928 55.352l37.831 37.831c-12.513 23.532-19.088 49.806-19.088 76.713 0 90.189 73.374 163.562 163.563 163.562h24.444l106.594 99.205v-99.205h12.166c90.189 0 163.562-73.374 163.562-163.562S438.626 85.124 348.438 85.124zM44.159 44.668c9.408-9.408 21.763-14.111 34.121-14.111 12.355 0 24.715 4.705 34.121 14.111l36.834 36.834 36.834-36.834c18.815-18.813 49.427-18.814 68.243.001 9.114 9.114 14.133 21.231 14.133 34.121 0 12.889-5.019 25.007-14.133 34.121L149.236 217.988 44.159 112.911c-18.814-18.815-18.814-49.428 0-68.243zm304.279 337.555h-42.192v60.27l-64.757-60.27h-36.255c-73.633 0-133.537-59.904-133.537-133.537 0-18.839 3.945-37.291 11.502-54.274l66.038 66.038 126.308-126.308a78.015 78.015 0 0 0 13.978-18.993h58.916c73.632 0 133.537 59.904 133.537 133.537S422.07 382.223 348.438 382.223z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.949 240.147h31.733v30.026h-31.733zM265.014 240.147h31.733v30.026h-31.733zM335.078 240.147h31.733v30.026h-31.733z",
    fill: "#ffffff",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.f29c5c6075e5f76def1d634d9f51e959.svg";
export { ForwardRef as ReactComponent };